goog.provide('el8.ptdata.nonvisitNotes');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.note.nonvisit');
goog.require('el8.service.urls');

/**
 * Nonvisit notes, including nonvisit notes imported from other practices
 */
el8.ptdata.nonvisitNotes = (function() {
    var that = new el8_EntitySet({
        model:el8.ptdata.model.note.nonvisit,
        deleteFn: function(item, successCb, errorCb) {
            var hadVitals = item.getVitalsCollections().length > 0;
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('deleteNonvisitNote', [item.getId()]),
                success: function() {
                    if (hadVitals) { $(document).trigger('el8_noteVitalUpdate'); }
                    if (successCb) { successCb.apply(null, arguments); }
                },
                error: errorCb
            });
        }
    });

    // We will not include notes from other practices by default
    var super_all = that.all;
    that.all = function(includeImportedNotes) {
        if (includeImportedNotes) {
            return super_all.call(that);
        } else {
            return _.reject(super_all.call(that), function(nvn) {
                return nvn.isImportedNote();
            });
        }
    };
    var super_sorted = that.sorted;
    that.sorted = function(includeImportedNotes) {
        if (includeImportedNotes) {
            return super_sorted.call(that);
        } else {
            return _.reject(super_sorted.call(that), function(nvn) {
                return nvn.isImportedNote();
            });
        }
    };

    that.forceDeleteItem = function(item, noNotify, opts) {
        opts = opts || {};
        var hadVitals = item.getVitalsCollections().length > 0;
        $.el8_ajax({
            type: 'DELETE',
            url: el8.service.urls.get('deleteNonvisitNote', [item.getId()])+'?force=1',
            success: function() { 
                that.remove(item, noNotify); 
                if (hadVitals) { $(document).trigger('el8_noteVitalUpdate'); }
                if (opts.successCb) { opts.successCb(item); }
            },
            error: opts.errorCb,
            error_msg: opts.error_msg
        });
    };
    that.deleteItemSendBackImages = function(item, noNotify, isForce) {
        
        var addlString = '?refile_images=1' + (isForce ? '&force=1' : '');
        
        $.el8_ajax({
            type: 'DELETE',
            url: el8.service.urls.get('deleteNonvisitNote', [item.getId()])+addlString,
            success: function() { that.remove(item, noNotify); }
        });
    };
    that.getUnsigned = function() {
        var all = that.all();
        for (var i=0; i<all.length; i++) {
            if (!all[i].getSignDate()) {
                return all[i];
            }
        }
        return null;
    };
    that.printNote = function(note) {
        var printPath = el8.service.urls.get('printNonvisitNote', [note.getId()]);
        if (el8Globals.APP === 'chart') {
            el8.appchart.printService.open({
                attachmentId: note.getId(),
                url: printPath
            });
        } else {
            window.open(printPath);
        }
    };
    return that;
})();